import React, { useState } from 'react';
import classnames from 'classnames/bind';
import { Icon } from '../Icon';
import styles from './Faq.css';

const cx = classnames.bind(styles);

const FAQ_ITEMS = [
    {
        question: 'Do I have to write anything?',
        answer: 'No. You can speak your answer and Boundly will transcribe it, or you can type. Your voice recording is never stored.'
    },
    {
        question: 'What if I don’t know what to say?',
        answer: 'Each question gives you something specific to respond to. You can answer as much or as little as you want, skip it, or return later.'
    },
    {
        question: 'What happens when a chapter is finished?',
        answer: 'Review it, keep it private, or share it with someone you choose. A completed category can also be saved as an ebook.'
    },
    {
        question: 'Can I cancel?',
        answer: 'Yes. Cancel anytime. You will keep access to the stories and chapters you have already completed.'
    }
];

function Faq() {
    const [openIndex, setOpenIndex] = useState(0);

    return (
        <div className={styles.root}>
            <h2 className={styles.heading}>People often ask</h2>
            <ul className={styles.list}>
                {FAQ_ITEMS.map((item, index) => {
                    const isOpen = index === openIndex;

                    return (
                        <li key={item.question} className={styles.item}>
                            <button
                                type='button'
                                className={styles.question}
                                onClick={() => setOpenIndex(isOpen ? null : index)}
                                aria-expanded={isOpen}
                            >
                                <span>{item.question}</span>
                                <Icon name='chevronDown' className={cx('chevronIcon', { isOpen })} />
                            </button>
                            {isOpen && <p className={styles.answer}>{item.answer}</p>}
                        </li>
                    );
                })}
            </ul>
        </div>
    );
}

export {
    Faq
};
